import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { AlertVariant, IAlert } from '../../components/alert-container/alert.interfaces';

export type ShowAlertParams = {
	variant?: AlertVariant;
	message: string;
	testId: string;
};

@Injectable({
	providedIn: 'root',
})
export class AlertService {
	alertState: IAlert;

	showAlert(payload: ShowAlertParams) {
		this.dispatch(payload);
	}

	success(message: string, testId: string) {
		this.dispatch({ message, variant: 'success', testId });
	}

	error(message: string, testId: string) {
		this.dispatch({ message, variant: 'error', testId });
	}

	private dispatch({ message, variant, testId }: ShowAlertParams) {
		this.alertState = {
			id: this.generateRandomId(),
			message: message,
			variant: variant ?? 'success',
			testId: testId,
			show: true,
		};
	}

	private generateRandomId() {
		return uuidv4();
	}
}
